import axios from 'axios';

export default class ApiService {
  static BASE_URL = 'https://daniel-airlines.up.railway.app/api';

  static saveToken(token) {
    localStorage.setItem('token', token);
  }

  static getToken() {
    return localStorage.getItem('token');
  }

  static saveRoles(roles) {
    localStorage.setItem('roles', JSON.stringify(roles));
  }

  static getRoles() {
    const roles = localStorage.getItem('roles');
    return roles ? JSON.parse(roles) : null;
  }

  static hasRole(role) {
    const roles = this.getRoles();
    return roles ? roles.includes(role) : false;
  }

  static isAdmin() {
    return this.hasRole('ADMIN');
  }

  static isCustomer() {
    return this.hasRole('CUSTOMER');
  }

  static isPilot() {
    return this.hasRole('PILOT');
  }

  static logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('roles');
  }

  static isAuthenticated() {
    const token = this.getToken();
    return !!token;
  }

  static getHeader() {
    const token = this.getToken();
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  //REGISTER USER

  static async registerUser(body) {
    const resp = await axios.post(`${this.BASE_URL}/auth/register`, body);
    return resp.data;
  }

  static async loginUser(body) {
    const resp = await axios.post(`${this.BASE_URL}/auth/login`, body);
    return resp.data;
  }

  //USER PROFILE MANAGMENT SESSION

  static async getAccountDetails() {
    const resp = await axios.get(`${this.BASE_URL}/users/me`, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  static async updateMyAccount(body) {
    const resp = await axios.put(`${this.BASE_URL}/users/me`, body, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  static async getAllPilots() {
    const resp = await axios.get(`${this.BASE_URL}/users/pilots`, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  //Airports API methods

  static async createAirports(body) {
    const resp = await axios.post(`${this.BASE_URL}/airports`, body, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  // ✅ CORREGIDO: Ahora recibe el ID como parámetro separado
  static async updateAirports(id, body) {
    const resp = await axios.put(`${this.BASE_URL}/airports/${id}`, body, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  // ✅ ALTERNATIVA: Si prefieres enviar el ID en el body (no recomendado)
  // static async updateAirports(body) {
  //   const resp = await axios.put(`${this.BASE_URL}/airports/${body.id}`, body, {
  //     headers: this.getHeader(),
  //   });
  //   return resp.data;
  // }

  static async getAllAirports() {
    const resp = await axios.get(`${this.BASE_URL}/airports`);
    return resp.data;
  }

  // ✅ CORREGIDO: Ahora envía el header de autenticación
  static async getAirportsById(id) {
    const token = this.getToken();

    // Debug: verifica si hay token
    if (!token) {
      console.error('No token found when fetching airport');
    }

    const resp = await axios.get(`${this.BASE_URL}/airports/${id}`, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  //BOOKING API METHODS

  static async createBooking(body) {
    const resp = await axios.post(`${this.BASE_URL}/bookings`, body, {
      headers: this.getHeader(),
    });
    return resp;
  }

  static async getBookingById(id) {
    const resp = await axios.get(`${this.BASE_URL}/bookings/${id}`, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  static async getAllBookings() {
    const resp = await axios.get(`${this.BASE_URL}/bookings`, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  static async getCurrentUserBookings() {
    const resp = await axios.get(`${this.BASE_URL}/bookings/me`, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  static async updateBookingStatus(id, status) {
    const resp = await axios.put(
      `${this.BASE_URL}/bookings/${id}`,
      { status },
      {
        headers: this.getHeader(),
      }
    );
    return resp.data;
  }

  //FLIGHT API METHODS

  static async createFlight(body) {
    const resp = await axios.post(`${this.BASE_URL}/flights`, body, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  static async getFlightById(id) {
    const resp = await axios.get(`${this.BASE_URL}/flights/${id}`);
    return resp.data;
  }

  static async getAllFlights() {
    const resp = await axios.get(`${this.BASE_URL}/flights`);
    return resp.data;
  }

  static async updateFlight(body) {
    const resp = await axios.put(`${this.BASE_URL}/flights`, body, {
      headers: this.getHeader(),
    });
    return resp.data;
  }

  static async searchFlights(departureAirportIata, arrivalAirportIata, departureDate) {
    const params = {
      departureAirportIata: departureAirportIata,
      arrivalAirportIata: arrivalAirportIata,
      departureDate: departureDate,
    };
    const resp = await axios.get(`${this.BASE_URL}/flights/search`, { params: params });
    return resp.data;
  }

  // ✅ CORREGIDO: Rutas correctas para cities y countries
  static async getAllCities() {
    const resp = await axios.get(`${this.BASE_URL}/flights/cities`);
    return resp.data;
  }

  static async getAllCountries() {
    const resp = await axios.get(`${this.BASE_URL}/flights/countries`);
    return resp.data;
  }
}
